import React from 'react'
import { push, navigateTo } from "gatsby-link"
import styled, { css } from 'styled-components'
import Link from 'gatsby-link'
import { VelocityComponent } from 'velocity-react'
import { Carousel } from '../'

if (typeof window !== 'undefined') {
	require('velocity-animate') 
	require('velocity-animate/velocity.ui') 
}

import logo from '../../assets/images/mambo-logo-footer.svg'

import { media, width } from '../../styles/utils'
import { container, bgIcon, padding, hoverState } from '../../styles/global'
import { red } from '../../styles/colors';

class Footer extends React.Component {

	state = {
		activeSlide: 0
	}

	renderQuotes = () => {
        const { data } = this.props;
        

		return data.quote_slider.map((quote, i) => {
			const active = i == this.state.activeSlide;
			return (
				<Quote>
					<VelocityComponent
						animation={active ? 'transition.slideUpIn' : 'transition.slideUpOut'}
						duration={800}
						delay={active ? 1000 : 0}
						easing={'easeOutCubic'}
						key={i}
						display={'flex'}
					>
						<QuoteWrapper>
							<Description>{quote.text}</Description>
							<Credit>- {quote.credit}</Credit>
						</QuoteWrapper>
					</VelocityComponent>
				</Quote>
			)
		})
	}

	beforeSlideChange = (i, nextSlide) => {
		this.setState({
			activeSlide: nextSlide
		})
	}

	render() {
		const { data } = this.props;
		
		return (
			<Wrapper>

				{/* Slider */}

				<Slider>
					<Container>
						{typeof window !== 'undefined' && (
							<Carousel
								slides={this.renderQuotes()}
								ref={this.slider}
								styles={carouselStyles}
								height={width.phone() ? 444 : 250}
								settings={{
									dots: false,
									arrows: false,
									infinite: true,
									speed: 2000,
									fade: true,
									slidesToShow: 1,
									slidesToScroll: 1,
									autoplay: true,
									autoplaySpeed: 2000,
									pauseOnHover: false,
									dragging: false,
									beforeChange: this.beforeSlideChange
								}}
							/>
						)}
					</Container>
				</Slider>

				{/* Copyright */}

				<Copyright>
					<Container>
						<Logo/>
						<Description>
							{data.copyright}
						</Description>
					</Container>
				</Copyright>

			</Wrapper>
		)
	}
}


const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: stretch;
	align-items: center;

	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: -1;

	${media.phone`
		bottom: 52px;
	`}
`

const Container = styled.div`
    ${container}
	flex-direction: column;
	${padding}
	width: 100%;
`

// Styles

const Heading = styled.div``
const Description = styled.div``

// Slider

const Slider = styled.div`
	background: #F3F3F3;
	width: 100%;
	display: flex;
	justify-content: center;
	min-height: 290px;
`

const carouselStyles = css`
	background: transparent;
`

const slideStyle = css`
	background: transparent;
`

const Credit = styled.div``

const Quote = styled.div`
	height: 290px;
	color: white;

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	${Description},
	${Credit} {
		font-family: 'Dot Stick';
		font-size: 16px;
		text-align: center;
		line-height: 40px;
		max-width: 655px;
		color: black;
	}

	${Credit} {
		font-size: 10px;
		margin-top: 30px;
		line-height: 0;
	}

	${media.phone`
		height: 444px;
		padding: 0 50px;

		${Description} {
			font-size: 12px;
		}

		${Credit} {
			margin-top: 25px;
			font-size: 7px;
		}
	`}
`

//  Required for animation

const QuoteWrapper = styled.div`
	display: flex;
	flex-direction: column;
`

// Copyright

const Copyright = styled.div`
	background: #161616;
	height: 60px;
	width: 100%;
	display: flex;
	justify-content: center;
	
	${Container} {
		display: flex;
		flex-direction: row;	
		justify-content: space-between;
		align-items: center;

		${Description} {
			font-family: 'GT America Expanded Bold';
			font-size: 12px;
			color: #848484;
			letter-spacing: 0;
			text-align: right;
			line-height: 62px;
		}
	}

	${media.phone`
		height: 80px;

		${Container} {
			flex-direction: column;
			justify-content: center;
			padding-top: 10px;
			box-sizing: border-box;

			${Description} {
				line-height: 22px;
				margin-top: 6px;
				font-size: 10px;
				text-align: center;
			}
		}
	`}
`

const Logo = styled.div`
	width: 137px;
	height: 15px;
	background-image: url(${logo});
	${bgIcon}
`


export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js